import React from 'react';
import { FiImage, FiTrash2 } from 'react-icons/fi';
import { HeaderCell } from './ListTableColumn';
import arrowUpIcon from '../../../../assets/image/arrow_up.svg';
import arrowDownIcon from '../../../../assets/image/arrowD.svg';
import { colorFormatTag, formatTag } from '../../../../utils/constant';
import TagHover from '../../product/components/tagHover';

export const getListDetailsTableColumns = (
	handleSort,
	sortDirection = {},
	handleRemoveProduct,
	expandedProductIds = [],
	handleToggleExpand,
	handleProductClick
) => [
	{
		field: 'PRODUCTNAME',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 240,
		flex: 1.5,
		headerComponent: () => (
			<HeaderCell field="PRODUCTNAME" label="PRODUCT NAME" handleSort={handleSort} sortDirection={sortDirection} />
		),
		cellRenderer: (params) => {
			const isBatch = params.data?.isBatch;
			if (isBatch) {
				return (
					<div className="d-flex align-items-center ps-4" data-testid={`batch-row-${params.data?.id}`}>
						<span className="fw-semibold text-dark">{params.value || params.data?.batch_no}</span>
					</div>
				);
			}

			const productId = params.data?.id;
			const isOpen = params.data?.isOpen ?? expandedProductIds.includes(productId);

			const tags = params.data?.tags || [];
			const status = params.data?.status;

			let firstTag = '';
			let otherTags = [];

			if (tags.length > 0) {
				firstTag = tags[0];
				otherTags = tags.slice(1);
			}

			return (
				<div
					className="d-flex align-items-center gap-2 w-100 h-100"
					data-testid={`product-name-link-${productId}`}
				>
					<img
						src={isOpen ? arrowUpIcon : arrowDownIcon}
						alt="toggle-accordion"
						className="accordion-arrow-icon flex-shrink-0 cursor-pointer"
						onClick={(e) => {
							e.stopPropagation();
							e.preventDefault();
							if (handleToggleExpand) handleToggleExpand(productId, e);
						}}
						data-testid={`accordion-toggle-btn-${productId}`}
					/>
					<div
						className="d-flex align-items-center gap-2 cursor-pointer flex-grow-1 h-100 ms-1"
						style={{ cursor: 'pointer' }}
						onClick={(e) => {
							e.stopPropagation();
							e.preventDefault();
							if (handleProductClick) handleProductClick(productId);
						}}
					>
						<div className="list-thumb-icon d-flex align-items-center justify-content-center rounded flex-shrink-0">
							<FiImage />
						</div>
						<span className="fw-semibold text-dark text-hover-underline flex-shrink-0">
							{params.value}
						</span>
						{tags.length > 0 && (
							<span
								className="product-status-badge"
								style={{
									backgroundColor: colorFormatTag(firstTag),
									color: firstTag === 'inactive' ? '#fff' : '#000',
								}}
							>
								{formatTag(firstTag)}
							</span>
						)}
						{otherTags.length > 0 && (
							<div className="tag-hover-wrapper">
								<TagHover tags={otherTags} />
							</div>
						)}
						{status === 2 && (
							<span className="product-status-badge draft-badge">
								Draft
							</span>
						)}
					</div>
				</div>
			);
		},
	},
	{
		field: 'UPC',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 200,
		flex: 1.2,
		headerComponent: () => <HeaderCell field="UPC" label="UPC" handleSort={handleSort} sortDirection={sortDirection} />,
		cellRenderer: (params) => <span className="text-dark">{params.value || '-'}</span>,
	},
	{
		field: 'CATEGORY',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 150,
		flex: 1,
		headerComponent: () => <HeaderCell field="CATEGORY" label="CATEGORY" handleSort={handleSort} sortDirection={sortDirection} />,
		cellRenderer: (params) => <span className="text-dark">{params.value || '-'}</span>,
	},
	{
		field: 'AVAILABLE STOCK',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 160,
		flex: 1,
		headerComponent: () => <HeaderCell field="AVAILABLE STOCK" label="AVAILABLE STOCK" handleSort={handleSort} sortDirection={sortDirection} />,
		cellRenderer: (params) => <span className="fw-semibold text-success">{params.value}</span>,
	},
	{
		field: 'UNIT PRICE',
		headerClass: 'HeaderBg right-align',
		cellClass: 'right-align',
		suppressSizeToFit: true,
		minWidth: 130,
		flex: 1,
		headerComponent: () => <HeaderCell field="UNIT PRICE" label="UNIT PRICE" handleSort={handleSort} sortDirection={sortDirection} isRight={true} />,
		cellRenderer: (params) => <span className="fw-semibold text-dark">{params.value}</span>,
	},
	{
		field: 'ACTIONS',
		headerName: 'ACTIONS',
		headerClass: 'HeaderBg text-center',
		cellClass: 'text-center',
		suppressSizeToFit: true,
		minWidth: 100,
		flex: 0.8,
		sortable: false,
		cellRenderer: (params) => {
			if (params.data?.isBatch) {
				return null;
			}
			return (
				<button
					type="button"
					className="btn p-1 text-danger border-0 bg-transparent"
					title="Remove Product from List"
					data-testid={`product-list-detail-remove-product-btn-${params.data?.id}`}
					onClick={() => handleRemoveProduct && handleRemoveProduct(params.data?.id)}
				>
					<FiTrash2 className="action-trash-icon" />
				</button>
			);
		},
	},
];

